import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);

(function installSongValleyProfessionalIcons() {
  if (window.__svProfessionalIconsGlobal) return;
  window.__svProfessionalIconsGlobal = true;

  const icons = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5v14M18 6l-9 6 9 6z"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 5v14M6 6l9 6-9 6z"/></svg>',
    volume: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6.5 9H3v6h3.5L11 19zM15 9a4 4 0 0 1 0 6M17.8 6.2a8 8 0 0 1 0 11.6"/></svg>',
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6.5 9H3v6h3.5L11 19zM16 9l5 6M21 9l-5 6"/></svg>',
    external: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 5h5v5M19 5l-9 9M18 13v6H5V6h6"/></svg>'
  };

  const style = document.createElement('style');
  style.textContent = '.sv-global-pro-icon{display:inline-grid;place-items:center;width:1.15em;height:1.15em;line-height:0;vertical-align:-.16em;flex:0 0 auto}.sv-global-pro-icon svg{display:block;width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;pointer-events:none}.sv-global-pro-icon svg path[fill]{stroke:none}';
  document.head.appendChild(style);

  const emojiPattern = /⏮️?|⏭️?|⏯️?|⏸️?|▶️?|⏵️?|🔊️?|🔉️?|🔈️?|🔇️?|↗️?|⬈️?/g;
  const iconName = (token) => {
    const value = token.replace(/️/g, '');
    if (value === '⏮') return 'prev';
    if (value === '⏭') return 'next';
    if (value === '⏸') return 'pause';
    if (value === '🔇') return 'muted';
    if (['🔊', '🔉', '🔈'].includes(value)) return 'volume';
    if (['↗', '⬈'].includes(value)) return 'external';
    return 'play';
  };

  function makeIcon(name) {
    const span = document.createElement('span');
    span.className = 'sv-global-pro-icon';
    span.dataset.svIcon = name;
    span.innerHTML = icons[name];
    return span;
  }

  function replaceEmojiText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const matches = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (emojiPattern.test(node.nodeValue || '')) matches.push(node);
      emojiPattern.lastIndex = 0;
    }
    matches.forEach((node) => {
      const text = node.nodeValue || '';
      const fragment = document.createDocumentFragment();
      let last = 0;
      text.replace(emojiPattern, (match, offset) => {
        if (offset > last) fragment.append(document.createTextNode(text.slice(last, offset)));
        fragment.append(makeIcon(iconName(match)));
        last = offset + match.length;
        return match;
      });
      if (last < text.length) fragment.append(document.createTextNode(text.slice(last)));
      node.replaceWith(fragment);
    });
  }

  function replaceIconOnlyButtons() {
    document.querySelectorAll('button,[role="button"]').forEach((button) => {
      if (button.querySelector('.sv-global-pro-icon')) return;
      const label = `${button.getAttribute('aria-label') || ''} ${button.getAttribute('title') || ''} ${button.dataset.action || ''}`.toLowerCase();
      if (!label || (button.textContent || '').trim()) return;
      let name = '';
      if (/previous|back track|skip back/.test(label)) name = 'prev';
      else if (/next|forward track|skip forward/.test(label)) name = 'next';
      else if (/unmute|muted/.test(label)) name = 'muted';
      else if (/mute|volume|sound/.test(label)) name = 'volume';
      else if (/pause/.test(label)) name = 'pause';
      else if (/play|resume/.test(label)) name = 'play';
      if (name) button.append(makeIcon(name));
    });
  }

  function scan() {
    document.querySelectorAll('button,a,[role="button"]').forEach(replaceEmojiText);
    replaceIconOnlyButtons();
  }

  let scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  }

  onDocumentReady(() => {
    scan();
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    ['play', 'pause', 'volumechange'].forEach((eventName) => document.addEventListener(eventName, scheduleScan, true));
    setTimeout(scan, 400);
  });
})();
